import React from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'

const FAQ = () => {
  const [openItems, setOpenItems] = React.useState({})

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }))
  }

  const faqData = [
    {
      question: "Was ist eine UID/USt-IdNr.?",
      answer: "Die Umsatzsteuer-Identifikationsnummer (USt-IdNr.) oder UID ist eine eindeutige Nummer, die Unternehmen in der EU für grenzüberschreitende Geschäfte erhalten. Sie beginnt mit dem Länderkürzel (z.B. DE für Deutschland, AT für Österreich)."
    },
    {
      question: "Welche UID-Formate werden unterstützt?",
      answer: "Vatly unterstützt alle gültigen EU-UID-Formate, einschließlich DE123456789 (Deutschland), ATU12345678 (Österreich), FR12345678901 (Frankreich) und alle anderen EU-Mitgliedsstaaten."
    },
    {
      question: "Wie funktioniert die UID-Prüfung?",
      answer: "Ihre eingegebene UID wird in Echtzeit gegen offizielle EU-Datenbanken geprüft. Bei einer gültigen UID erhalten Sie sofort die Unternehmensdaten und können optional eine PDF-Bestätigung herunterladen."
    },
    {
      question: "Werden meine eingegebenen UIDs gespeichert?",
      answer: "Nein, wir speichern keine UIDs dauerhaft. Die eingegebenen Nummern werden ausschließlich für die Prüfung verwendet und anschließend gelöscht. Ihre Privatsphäre ist uns wichtig."
    },
    {
      question: 'Was bedeutet "UID nicht gefunden"?',
      answer: "Dies kann verschiedene Ursachen haben: Die UID existiert nicht, wurde noch nicht in der EU-Datenbank registriert, oder es liegt ein Tippfehler vor. Bitte überprüfen Sie die Eingabe und versuchen Sie es erneut."
    },
    {
      question: "Kann ich die PDF-Bestätigung für rechtliche Zwecke nutzen?",
      answer: "Ja, die generierte PDF-Bestätigung kann als offizielle Bestätigung der UID-Gültigkeit verwendet werden. Sie enthält alle relevanten Unternehmensdaten und das Prüfdatum."
    },
    {
      question: "Ist die Nutzung von Vatly kostenlos?",
      answer: "Ja, die UID-Prüfung mit Vatly ist vollständig kostenlos. Es fallen keine Gebühren für die Nutzung der Plattform an."
    },
    {
      question: "Wie aktuell sind die Daten?",
      answer: "Unsere Datenbank wird täglich mit den offiziellen EU-Registern synchronisiert. Die angezeigten Informationen sind daher immer auf dem neuesten Stand."
    },
    {
      question: "Funktioniert Vatly auch auf mobilen Geräten?",
      answer: "Ja, Vatly ist vollständig responsive und funktioniert optimal auf Desktop-Computern, Tablets und Smartphones. Sie können die UID-Prüfung überall durchführen."
    },
    {
      question: "Was soll ich tun, wenn eine UID als ungültig angezeigt wird, obwohl sie gültig ist?",
      answer: `Bitte kontaktieren Sie uns unter ${['help', '@', 'vatly', '.', 'at'].join('')} mit der betroffenen UID. Wir prüfen das Problem und aktualisieren unsere Datenbank bei Bedarf.`
    }
  ]

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-dark-900 dark:to-dark-800 transition-colors duration-300">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
              Häufige Fragen
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-400">
              Hier finden Sie Antworten auf die wichtigsten Fragen zu Vatly.
            </p>
          </div>

          <div className="space-y-4">
            {faqData.map((item, index) => (
              <div key={index} className="bg-white dark:bg-dark-800 shadow-lg rounded-xl border border-gray-200 dark:border-dark-700 overflow-hidden">
                <button
                  onClick={() => toggleItem(index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 dark:hover:bg-dark-700 transition-colors duration-200"
                >
                  <span className="font-medium text-gray-900 dark:text-white pr-4">
                    {item.question}
                  </span>
                  {openItems[index] ? (
                    <ChevronUp className="w-5 h-5 text-gray-500 dark:text-gray-400 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-gray-500 dark:text-gray-400 flex-shrink-0" />
                  )}
                </button>
                
                {openItems[index] && (
                  <div className="px-6 pb-4">
                    <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <div className="bg-white dark:bg-dark-800 rounded-xl p-8 border border-gray-200 dark:border-dark-700">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                Weitere Fragen?
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Falls Sie weitere Fragen haben, kontaktieren Sie uns gerne.
              </p>
              <a
                href={`mailto:${['help', '@', 'vatly', '.', 'at'].join('')}`}
                className="inline-flex items-center gap-2 btn-primary"
              >
                {['help', '@', 'vatly', '.', 'at'].join('')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FAQ
